<footer class="app-footer">
      <div class="footer-content">
        <!-- Tagline -->
        <h2 class="tagline">
          Rooted in South Indian Heritage,<br>
          <span class="highlight">crafted for today.</span>
        </h2>

        <!-- Address -->
        <p class="address">
          Plot No 12, Krishna Nagar, Panch batti Airforce, Defence Lab Road Ratanada, Jodhpur, Rajasthan. 342001
        </p>

        <!-- Google Map (loaded on demand) -->
        <div class="map-container">
          @if (mapExpanded()) {
            <iframe
              title="Restaurant location on Google Maps"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3577.8!2d73.0371203!3d26.2676238!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39418d9be9e31b8d%3A0x820427f902583eb4!2sUnaavu!5e0!3m2!1sen!2sin!4v1720000000000!5m2!1sen!2sin"
              width="100%"
              height="250"
              style="border:0;"
              allowfullscreen=""
              loading="lazy"
              referrerpolicy="no-referrer-when-downgrade">
            </iframe>
          } @else {
            <button type="button" class="map-load-btn" (click)="showMap()">
              Show map
            </button>
          }
        </div>

        <!-- Social Icons -->
        <div class="social-buttons">
          <a href="https://www.facebook.com/unaavukitchen" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
            <fa-icon [icon]="faFacebookF"></fa-icon>
          </a>
          <a href="https://wa.me/917042538830" target="_blank" rel="noopener noreferrer" aria-label="WhatsApp">
            <fa-icon [icon]="faWhatsapp"></fa-icon>
          </a>
          <a href="https://www.instagram.com/unaavukitchen" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
            <fa-icon [icon]="faInstagram"></fa-icon>
          </a>
        </div>

        <app-footer-legal-policies></app-footer-legal-policies>

        <nav class="footer-links" aria-label="Company and legal">
          <a routerLink="/work-with-us">Work with us</a>
          <a routerLink="/privacy">Privacy Policy</a>
          <a routerLink="/privacy/facebook">Facebook Privacy</a>
          <a routerLink="/privacy/instagram">Instagram Privacy</a>
          <a routerLink="/cookies">Cookies Policy</a>
          <a routerLink="/about">About us</a>
          <a routerLink="/terms-of-service">Terms of Service</a>
        </nav>

        <p class="copyright">© {{ currentYear }} Unaavu. All rights reserved.</p>

        <app-powered-by-vana [compact]="true"></app-powered-by-vana>
      </div>
    </footer>